// extracted by mini-css-extract-plugin
export var actions = "_qg-4";
export var item = "_qg-1";
export var price = "_qg-3";
export var quantity = "_qg-2";
export var table = "_qg-0";